module.exports = __webpack_public_path__ + "files/45de5488c869f87b35ae598ad15261b9.png";